export const ENVIRONMENTS = {
  development: 'development',
  test: 'test',
  preview: 'preview',
  staging: 'staging',
  production: 'production',
}

const envTest = process.env.NODE_ENV == ENVIRONMENTS.test
const envPreview = process.env.NODE_ENV == ENVIRONMENTS.preview
const envStaging = process.env.NODE_ENV == ENVIRONMENTS.staging
const envProduction = process.env.NODE_ENV == ENVIRONMENTS.production
const envOnline = envPreview || envStaging || envProduction
const env = {
  development: !envTest && !envOnline,
  test: envTest,
  preview: envPreview,
  staging: envStaging,
  production: envProduction,
  online: envOnline,
}

for (const k in env) {
  if (env[k]) {
    env.current = k
    break
  }
}
export default env
